import React, { Fragment } from 'react'
import Navbar2 from '../../components/Navbar2/Navbar2'
import PageTitle from '../../components/pagetitle/PageTitle'
import UseCases from '../../components/csp/UseCases'
import CirclesTeaser from '../../components/csp/CirclesTeaser'
import IntegrationSteps from '../../components/csp/IntegrationSteps'
import WalkthroughCta from '../../components/csp/WalkthroughCta'
import Footer from '../../components/footer/Footer'
import Scrollbar from '../../components/scrollbar/scrollbar'

const HowItWorksPage = () => {
  return (
    <Fragment>
      <Navbar2 />
      <PageTitle pageTitle={'How it works'} pagesub={'How it works'} />
      <UseCases />
      <CirclesTeaser />
      <IntegrationSteps />
      <WalkthroughCta />
      <Footer />
      <Scrollbar />
    </Fragment>
  )
}

export default HowItWorksPage
